/*
 *
 * Configuration constants
 *
 */

export const DEFAULT_ACTION = "app/Configuration/DEFAULT_ACTION"

export const GET_CONFIGURATION_WATCHER =
  "app/Configuration/GET_CONFIGURATION_WATCHER"
export const GET_CONFIGURATION_SUCCESS =
  "app/Configuration/GET_CONFIGURATION_SUCCESS"
export const GET_CONFIGURATION_FAILED =
  "app/Configuration/GET_CONFIGURATION_FAILED"

export const PUT_CONFIGURATION_WATCHER =
  "app/Configuration/PUT_CONFIGURATION_WATCHER"
export const PUT_CONFIGURATION_SUCCESS =
  "app/Configuration/PUT_CONFIGURATION_SUCCESS"
export const PUT_CONFIGURATION_FAILED =
  "app/Configuration/PUT_CONFIGURATION_FAILED"
